import { post } from "@insite/client-framework/Services/ApiService";
import { DealerAccountRequestModel } from "@insite/client-framework/Types/ApiModels";

export async function submitDealerAccountRequest(dealerAccountRequest: DealerAccountRequestModel) {
    const response = await post<DealerAccountRequestModel>("api/dealer-account-requests", dealerAccountRequest);
    return response;
}
